import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class CommunitiesService {
  constructor(private http: HttpClient) {}

  public fetchCommunities(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/communities`
    return this.http.post(url, params)
  }
  public fetchCommunity(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/community/${id}`
    return this.http.get(url, {})
  }

  public deleteCommunity(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/community/${id}`
    return this.http.delete(url)
  }

  public createCommunity(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/community`
    return this.http.post(url, params)
  }

  public updateCommunity(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/community/${id}`
    return this.http.put(url, params)
  }
}
